import { render, staticRenderFns } from "./newChat.vue?vue&type=template&id=16ad2af3&"
import script from "./newChat.vue?vue&type=script&lang=js&"
export * from "./newChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports